$(function () {
    const App = window.App;
    const key = 'cookiePolicyAcceptedAt';
    const elementId = 'cookieNotification';

    App.acceptCookiePolicy = function () {
        localStorage.setItem(key, Date.now());
        
        document.getElementById(elementId).classList.add('hidden');
    };

    const initCookieNotification = function () {
        const date = localStorage.getItem(key);

        if (!date) {
            document.getElementById(elementId).classList.remove('hidden');
        }
    };

    initCookieNotification();
});
